import { Button, CircularProgress, Paper } from '@mui/material';
import {} from 'react';
import AppPaperContent from 'src/app/common/components/AppPaperContent';
import useStyles from './BatchFileActions.styles';
import { useIntl } from 'react-intl';
import { useReassignAgentForHoldPoliciesContext } from '../../ReassignAgentForHoldPolicies.context';

const BatchFileActions = () => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { isSubmitting, submitBdmHoldPolicies } = useReassignAgentForHoldPoliciesContext();
  const { classes } = useStyles();

  return (
    <Paper>
      <AppPaperContent className={classes.paperContent}>
        <Button
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          variant="contained"
          color="secondary"
          onClick={submitBdmHoldPolicies}
          disabled={isSubmitting}
        >
          {Translation('opm_pd.submit')}
        </Button>
      </AppPaperContent>
    </Paper>
  );
};

export default BatchFileActions;
